import {Layout} from '@ui-kitten/components';
import React from 'react';
import {Platform, StyleSheet} from 'react-native';
import {getHelpVideo} from '../../apis';
import window from '../../constants/Layout';
import {px, useAsync} from '../../utils';
import {AppLoadingIndicator, Page} from '../components';
import CardsList from './components/CardsList';

const VideoHelpPage = () => {
  const {loading, value: list} = useAsync(() => getHelpVideo());

  return (
    <Page
      style={styles.container}
      header={{title: 'FAQ', showDrawerAction: true}}>
      <Layout style={styles.viewStyle}>
        {loading ? <AppLoadingIndicator /> : <CardsList data={list} />}
      </Layout>
    </Page>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingBottom: px(50),
  },
  viewStyle: {
    height: Platform.OS === 'web' ? '75vh' : window.window.height,
    paddingBottom: px(90),
  },
});

export default VideoHelpPage;
